document.addEventListener('DOMContentLoaded', function () {
  function getQikifyQuantity() {
    const checkedTier = document.querySelector('.qvl-volume-tier__radio__input--checked');
    if (!checkedTier) return 1;
    const wrapper = checkedTier.closest('.qvl-volume-tier__wrapper');
    const titleEl = wrapper?.querySelector('.qvl-volume-tier__title');
    const match = titleEl?.textContent.match(/\d+/);
    return match ? parseInt(match[0]) : 1;
  }

  document.addEventListener('click', function (e) {
    const buyNowBtn = e.target.closest('.product-form__buy-now');
    if (!buyNowBtn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const form = buyNowBtn.closest('form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const quantity = getQikifyQuantity();

    if (!variantId) return;

    buyNowBtn.disabled = true;

    fetch('/cart/clear.js', { method: 'POST' })
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
      }))
      .then(() => { window.location.href = '/checkout'; })
      .catch(err => {
        console.error('Buy Now error:', err);
        buyNowBtn.disabled = false;
      });
  }, true); // true = capture phase, roda ANTES do onclick nativo
});

